import React from 'react';

import image from './graduate.gif';
import './AcademicDetails.css';

const skills = [
  "leadership", " clear communication","attention to detail", "critical thinking", "project and product management", "Software and Software product testing",
  "stroytelling", "writting", "social media management and analytics", "user-centered product design", "hardware and software troubleshooting and debbugging", "mentoring"
]

const detailSummary = (
  <div id="academia" className="mt-3 mt-lg-0 mb-5 mb-lg-0 pb-4 container justify-content-center">

    <div>
      <div className="bg-page text-center pt-5 pb-5">
        <h1 className='bg-title '><span><strong> Background and Volunteering </strong></span></h1>
      </div>
        <p className="pb-3 pt-5">
          I was born and raised in Nairobi, Kenya and I have a Diploma/Associate's Degree in <strong>Information Technology</strong> from <strong>Jomo Kenyatta University of Agriculture & Technology</strong>. 
        </p>
        <p> Prior to pursuing a path in Software Engineering, I gathered 10<sup><strong>+</strong></sup> years of experience pursuing different roles that align with my interests and held the following titles:- IT administrator, personal assistant, office manager, poetess, actress, orator, narrator, script writer,
          editor, call center support personnel, social media manager and quality assurance personel. </p>
        <p>
        These roles equipped me with a myriad of skills among them:-
        </p>
        <div className="row pb-3">
            {skills.map((skill, i)=>{
              return (
                <div key={i} className="col-md-6">
                  {i % 2 == 0 ? 
                  <ul>
                  <li id={`skill + i`} style={{whiteSpace: 'pre-line'}} >{skill}</li>
                </ul> 
                : 
                <ul>
                  <li id={i} style={{whiteSpace: 'pre-line'}} >{skill}</li>
                </ul>
                  }
                </div>   
              )
            })}
        </div>
      <p className="pb-3">
          Since 2017, I have been focussed on self-learning and working within various organisations in the space of Fullstack software development to further my skillset. 
          In the near future, I hope to keep pursuing knowlege in Computer Science and expand into fields like; Artificial Intelligence, Machine Learning and Data Science, whose concepts I am keen to learn.
          Being a self-taught Software Engineer has thus far renewed my belief that:- "There is more than one way to learn, practice and be good at something you love".
      </p>
      <p className="pb-5">
          In my free time, I enjoy watching films/series and rewatching those I enjoyed as a child. I love singing and will fiddle with my guitar every so often. I enjoy travel, sampling food and live music or comedy shows. I recently picked up motorcycling and I am working towards being a safe rider.
          I enjoy learning about the universe, how the mind works, the logic behind held beliefs and philosophies, science and nature, so you will also find me buried in books or chasing down rabbit holes on the web. I go out dancing whenever I am up for it(when my introvesion allows) and will pick up a novel if it promises to intrigue
          and feed my imagination. 
      </p>
      <div className="text-center pb-5">
        <a role="button" id="contact" className="nav-item btn btn-outline-secondary btn-lg" href="/portfolio">
          <span className="nav-link mb-0 pt-0 pb-0 pl-5 pr-5">
            View Projects & Links
          </span>
        </a>
      </div>
    </div>
    <h2 className="mt-3 mb-0 pb-0">What I've Been Up To.</h2>
    <hr className="mb-4 mt-1"/>
    <h4><u>Software Engineering Work Experience</u></h4>
    <br />
    <div id="academia-details" className="col-md-12">
      <ul>
        <li className="pb-3">
          <strong>January 2022 - Present: </strong> Joined <strong>The Mawazo Institute</strong> team as the <strong> Software Engineering and Technology(SET) Lead</strong> in charge of the SET department. Facilated the upgrade of the WordPress learning site,
          took part in the establishment of the Strategic plan 2023 - 2026, researched, recommended and oversaw the automation of internal processes with technology tools and laid the foundation for a Technology department. 
          Planned, budgeted, managed and developed an end-to-end applications with Fullstack Javascript and other tools whilst mentoring a junior team members. 
        </li>
        <li className="pb-3">
          <strong>August 2020 - December 2022: </strong> Worked as a contractor with <strong>The Mawazo Institute</strong> to set up and create a WordPress learning website with a membership wall, custom roles and features with Learndash.
          Also upgraded the design of the main website with SquareSpace. Also did freelance work with several people on personal projects.
        </li>
        <li className="pb-3">
          <strong>August 2018 - May 2020: </strong> Joined the <strong>Bellwethr</strong> team as an Andela fellow and worked fulltime as an Individual Contributor working with fullstack Python/Django, Vanilla JS and ReactJS.
          Later helped with onboarding the growing team and as a Lead Developer, whilst mentoring an intern and working with the marketing and UX design teams.
        </li>
        <li className="pb-3">
          <strong>April 2017 - October 2020: </strong> Was accepted to the <strong>Andela Fellowship</strong> from a pool of 1000<sup><strong>+</strong></sup> applicants.
          I was involved in various supported self-learning projects for several months, where I specialiazed in Full-Stack Javascript and dabbled in the Python language.
          Participated in mentoring within and outside of Andela via bootcamp facilitation and the TeenCode initiative.
        </li>
        
        
        
      </ul>
    </div>
    <br />
    <h4><u>Volunteering</u></h4>
    <br /> 
    <div id="academia-details" className="col-md-12">
      <ul>
      <li className="pb-3">
          <strong>November 2019 - November 2022: </strong> Volunteered as a <strong>Board Member</strong> within <strong>Rotary Club of Lavington Jioni(District 9212)</strong> where I particiapted in Board roles and responsibilities. I also held the roles of <strong>New Generation Director (2020/21) </strong>
          and <strong>Monitoring and Evaluation Director (2021/22)</strong> working alongside the membership committee on new approaches to increase membership retainment and engage new members, and monitoring club goals and pursuing accountability and delivery to help the club better accomplish the set goals within the designated timelines, respectively.
        </li>
      
        <li className="pb-3">
          <strong>September 2017 - October 2020: </strong> Volunteed as a <strong>Facilitator</strong> and <strong>Mentor</strong> through <strong>TeenCode Africa</strong> where I particiapted in mentoring High School students and young adults working in various Technology institutions.
        </li>
        <li className="pb-3">
          <strong>March 2010 - May 2010: </strong> Volunteered as an <strong>Adult Caregiver</strong> for a family of a brain tumor patient who could not afford to acquire the services of a full time nurse.
        </li>
        <li className="pb-3">
          <strong>July 2009 - August 2009: </strong> Volunteered as a <strong>Peer Educator/ Counselor</strong> and <strong>Vocalist</strong> through <strong>Cooperazione Internazaionale</strong> where we worked on an Arts project, the Cheza Project Kibera; which revolved around humanitarian efforts
        </li>
        <li className="pb-3">
          <strong>May 2006 - May 2007: </strong> Volunteered as a <strong>Vocalist/ Lead Singer</strong> through <strong>The Alliance Française Band</strong> where we offered free musical entertainment for Nairobi-based Kenyans eapecially around the holidays.
        </li>
        <li className="pb-3">
          I have attended several First Aid trainings through the course of my life and apply those skills in relevant settings as they are needed. 
        </li>
        <li className="pb-3">
          I continuously engage within various minority groups to drive change through art, grassroot education and advocacy. 
        </li>
      </ul>
    </div>
  </div>
);

const AcademicDetails = () => {
  return detailSummary;
}

export default AcademicDetails;
